const selectData = (state) => state.groupsettings.wizard.data
const selectLoader = (state) => state.groupsettings.wizard.loader
const selectError = (state) => state.groupsettings.wizard.error
const selectInfoFormError = (state) => state.groupsettings.wizard.infoFormError

const selectEndUserAlerts = (state) => state.groupsettings.wizard.endUserAlerts

const selectCurrentWizardStep = (state) => state.groupsettings.wizard.currentWizardStep
const selectIsDefault = (state) => state.groupsettings.wizard.isDefault
const selectHasExistingDefault = (state) => state.groupsettings.wizard.hasExistingDefault
const selectShowSavedModal = (state) => state.groupsettings.wizard.showSavedModal

const selectInfoFormSaved = (state) => state.groupsettings.wizard.infoFormSaved

const selectEditName = (state) => state.groupsettings.wizard.editName

export {
  selectData,
  selectLoader,
  selectError,
  selectCurrentWizardStep,
  selectIsDefault,
  selectHasExistingDefault,
  selectShowSavedModal,
  selectInfoFormSaved,
  selectEndUserAlerts,
  selectEditName,
  selectInfoFormError,
}
